export default __webpack_public_path__ + "static/media/mist.bec995ef.png";